/**
 * TimelineCard - Card individual da linha do tempo
 * 
 * Mostra um período/fase da jornada do autor com:
 * - Período (ano/fase)
 * - Título da fase
 * - Estilo de escrita
 * - Pensamento
 * - Trecho representativo
 */

import React from 'react';

export default function TimelineCard({
  period,
  title,
  writingStyle,
  thought,
  excerpt,
  isActive = false,
  onCompare,
}) {
  return (
    <div
      className={`
        timeline-card relative flex-shrink-0 w-[70vw] max-w-[600px]
        rounded-2xl overflow-hidden
        transition-all duration-500 ease-out
        ${isActive 
          ? 'scale-100 opacity-100 shadow-xl z-10' 
          : 'scale-[0.92] opacity-80'
        }
      `}
      style={{
        background: isActive 
          ? 'linear-gradient(145deg, #faf8f5 0%, #f5f0e8 100%)'
          : 'linear-gradient(145deg, #f5f2ed 0%, #ebe6dc 100%)',
        border: isActive ? '1px solid rgba(180, 160, 130, 0.3)' : '1px solid rgba(180, 160, 130, 0.15)',
      }}
      data-testid="timeline-card"
    >
      {/* Decorative corner */}
      <div 
        className="absolute top-0 right-0 w-20 h-20 opacity-10"
        style={{
          background: 'radial-gradient(circle at top right, #b8a080 0%, transparent 70%)',
        }}
      />

      <div className="relative p-6 md:p-8">
        {/* Period badge */}
        <div className="flex items-center gap-3 mb-4">
          <span 
            className="px-3 py-1 text-xs font-medium tracking-wider uppercase rounded-full"
            style={{ 
              backgroundColor: 'rgba(180, 160, 130, 0.15)',
              color: '#8b7355',
            }}
          >
            {period}
          </span>
          {isActive && (
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
          )}
        </div>

        {/* Phase title */}
        <h3 
          className="text-xl md:text-2xl font-serif mb-4"
          style={{ color: '#3a3a3a' }}
        >
          {title}
        </h3>

        {/* Writing style */}
        <div className="mb-4">
          <p className="text-xs uppercase tracking-wider text-stone-400 mb-1">
            Estilo de Escrita
          </p>
          <p className="text-sm text-stone-600 leading-relaxed">
            {writingStyle}
          </p>
        </div>

        {/* Thought/mindset */}
        <div className="mb-5">
          <p className="text-xs uppercase tracking-wider text-stone-400 mb-1">
            Pensamento
          </p>
          <p className="text-sm text-stone-600 leading-relaxed italic">
            "{thought}"
          </p>
        </div>

        {/* Representative excerpt */}
        <div 
          className="p-4 rounded-lg mb-5"
          style={{ backgroundColor: 'rgba(180, 160, 130, 0.08)' }}
        >
          <p className="text-xs uppercase tracking-wider text-stone-400 mb-2">
            Trecho Representativo
          </p>
          <p 
            className="text-sm leading-relaxed font-serif"
            style={{ color: '#4a4a4a' }}
          >
            "{excerpt}"
          </p>
        </div>

        {/* Compare button */}
        <button
          onClick={onCompare}
          className={`
            w-full py-3 px-4 rounded-lg text-sm font-medium
            transition-all duration-300
            ${isActive 
              ? 'bg-amber-100 text-amber-800 hover:bg-amber-200' 
              : 'bg-stone-100 text-stone-500 hover:bg-stone-200'
            }
          `}
        >
          Comparar com hoje
        </button>
      </div>
    </div>
  );
}
